/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AnswerJsonldAnswerRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  content?: string;
  id?: number;
}

export interface AnswerJsonldCommentReadAnswerRead {
  comment?: GarageCommentJsonldCommentReadAnswerRead | null | (GarageCommentJsonldCommentReadAnswerRead & null);
  content?: string;
  id?: number;
}

export interface AnswerJsonldGarageReadIdGarageReadNameCommentReadAnswerRead {
  comment?:
    | GarageCommentJsonldGarageReadIdGarageReadNameCommentReadAnswerRead
    | null
    | (GarageCommentJsonldGarageReadIdGarageReadNameCommentReadAnswerRead & null);
  content?: string;
  id?: number;
}

export interface BrandSpecializationJsonldBrandSpecializationReadSpecializationRead {
  description?: string;
  id?: number;
  main?: boolean;
  name?: string;
  slug?: string;
}

export interface BrandSpecializationJsonldSpecializationRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  description?: string;
  id?: number;
  main?: boolean;
  name?: string;
  slug?: string;
}

export interface GarageJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead {
  id?: number;
}

export interface GarageJsonldGarageReadIdGarageReadNameCommentReadAnswerRead {
  id?: number;
  name?: string;
}

export interface GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  address?: string;
  city?: string;
  citySlug?: string;
  commentsNegative?: number;
  commentsNeutral?: number;
  commentsPositive?: number;
  commentsTotal?: number;
  description?: string;
  id?: number;
  lat?: string;
  lng?: string;
  name?: string;
  nameSlug?: string;
  noClientParts?: boolean;
  onlineBooking?: boolean;
  /**
   * @default true
   * @example true
   */
  paymentWithCash?: boolean;
  paymentWithCreditCard?: boolean;
  phone?: string;
  postalCode?: string;
  premium?: boolean;
  quarter?: string;
  quarterSlug?: string;
  ratingPrice?: number;
  ratingService?: number;
  ratingTime?: number;
  ratingTotal?: number;
  seoMetaDescription?: string;
  state?: number;
  visitsFromLast30Days?: number;
}

export interface GarageJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead {
  id?: number;
}

export interface GarageJsonldSlugHistoryReadGarageSlugHistoryRead {
  citySlug?: string;
  id?: number;
  nameSlug?: string;
}

export interface GarageJsonldSuggestedGarageReadRankingRead {
  address?: string;
  city?: string;
  citySlug?: string;
  commentsTotal?: number;
  id?: number;
  name?: string;
  nameSlug?: string;
  quarter?: string;
  ratingTotal?: number;
  visitsFromLast30Days?: number;
}

export interface GarageAutobookingIntegrationJsonldAutobookingIntegrationRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  enabled?: boolean;
  garageId?: number;
  ziloIdentifier?: string;
}

export interface GarageBrandSpecializationJsonldBrandSpecializationReadSpecializationRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  brandSpecialization?:
    | BrandSpecializationJsonldBrandSpecializationReadSpecializationRead
    | null
    | (BrandSpecializationJsonldBrandSpecializationReadSpecializationRead & null);
  id?: number;
}

export interface GarageCommentJsonldCommentReadAnswerRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  answers?: AnswerJsonldCommentReadAnswerRead[];
  car?: string;
  created?: number;
  description?: string;
  id?: number;
  name?: string;
  ratingPrice?: number;
  ratingService?: number;
  ratingTime?: number;
  ratingTotal?: number;
  state?: number;
  trusted?: number;
  type?: number;
}

export interface GarageCommentJsonldGarageReadIdGarageReadNameCommentReadAnswerRead {
  "@id"?: string;
  "@type"?: string;
  answers?: AnswerJsonldGarageReadIdGarageReadNameCommentReadAnswerRead[];
  car?: string;
  created?: number;
  description?: string;
  garage?:
    | GarageJsonldGarageReadIdGarageReadNameCommentReadAnswerRead
    | null
    | (GarageJsonldGarageReadIdGarageReadNameCommentReadAnswerRead & null);
  id?: number;
  name?: string;
  ratingPrice?: number;
  ratingService?: number;
  ratingTime?: number;
  ratingTotal?: number;
  state?: number;
  trusted?: number;
  type?: number;
}

export interface GarageCommentStatisticsJsonldCommentsStatisticsRead {
  "@id"?: string;
  "@type"?: string;
  id?: number;
  ratingPrice?: number;
  ratingService?: number;
  ratingTime?: number;
  ratingTotal?: number;
}

export interface GarageDomainJsonldDomainRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  domain?: string;
  garageId?: number;
}

export interface GarageFixedPriceListJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  description?: string;
  garage?:
    | GarageJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead
    | null
    | (GarageJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead & null);
  id?: number;
  name?: string;
  priceGross?: number;
  priceNet?: number;
  priceService?:
    | PriceServiceJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead
    | null
    | (PriceServiceJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead & null);
}

export interface GarageIdentifierBySlugJsonldGarageRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  id?: number;
  slug?: string;
  slugCity?: string;
}

export interface GarageImageJsonldGarageImageRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  description?: string | null;
  id?: number;
  primary?: boolean;
  title?: string | null;
  type?: string;
  url?: string;
}

export interface GarageRangePriceListJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  description?: string;
  garage?:
    | GarageJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead
    | null
    | (GarageJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead & null);
  id?: number;
  name?: string;
  priceFrom?: number;
  priceService?:
    | PriceServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead
    | null
    | (PriceServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead & null);
  priceTo?: number;
  promoted?: boolean;
  service?:
    | ServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead
    | null
    | (ServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead & null);
}

export interface GarageSupportedServiceJsonldSupportedServiceReadServiceRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  id?: number;
  service?: ServiceJsonldSupportedServiceReadServiceRead | null | (ServiceJsonldSupportedServiceReadServiceRead & null);
}

export interface GarageTagJsonldGarageTagReadTagRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  id?: number;
  tag?: TagJsonldGarageTagReadTagRead | null | (TagJsonldGarageTagReadTagRead & null);
}

export interface GarageVirtualPhoneNumberJsonldVirtualPhoneRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  active?: boolean;
  forwardToCallCenter?: boolean;
  forwardToMechanic?: boolean;
  id?: number;
  phoneFormatted?: string;
  phoneVirtual?: string;
}

export interface GarageWorkTimeJsonldWorkTimeRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  friday?: {
    /** @example "12:00" */
    from?: string;
    open?: boolean;
    /** @example "12:00" */
    to?: string;
  };
  garageId?: number;
  monday?: {
    /** @example "12:00" */
    from?: string;
    open?: boolean;
    /** @example "12:00" */
    to?: string;
  };
  saturday?: {
    /** @example "12:00" */
    from?: string;
    open?: boolean;
    /** @example "12:00" */
    to?: string;
  };
  sunday?: {
    /** @example "12:00" */
    from?: string;
    open?: boolean;
    /** @example "12:00" */
    to?: string;
  };
  thursday?: {
    /** @example "12:00" */
    from?: string;
    open?: boolean;
    /** @example "12:00" */
    to?: string;
  };
  tuesday?: {
    /** @example "12:00" */
    from?: string;
    open?: boolean;
    /** @example "12:00" */
    to?: string;
  };
  wednesday?: {
    /** @example "12:00" */
    from?: string;
    open?: boolean;
    /** @example "12:00" */
    to?: string;
  };
}

export interface PriceCategoryJsonld {
  "@id"?: string;
  "@type"?: string;
  id?: number;
  name?: string;
}

export interface PriceCategoryJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead {
  id?: number;
  name?: string;
}

export interface PriceCategoryJsonldPriceCategoryRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  id?: number;
  name?: string;
}

export interface PriceCategoryJsonldPriceServiceReadServiceReadPriceCategoryRead {
  id?: number;
  name?: string;
}

export interface PriceCategoryJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead {
  id?: number;
  name?: string;
}

export interface PriceServiceJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead {
  description?: string;
  id?: number;
  name?: string;
  priceCategory?:
    | PriceCategoryJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead
    | null
    | (PriceCategoryJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead & null);
  service?:
    | ServiceJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead
    | null
    | (ServiceJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead & null);
  surcharge?: boolean;
  type?: string;
}

export interface PriceServiceJsonldPriceServiceReadServiceReadPriceCategoryRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  description?: string;
  id?: number;
  name?: string;
  priceCategory?:
    | PriceCategoryJsonldPriceServiceReadServiceReadPriceCategoryRead
    | null
    | (PriceCategoryJsonldPriceServiceReadServiceReadPriceCategoryRead & null);
  service?:
    | ServiceJsonldPriceServiceReadServiceReadPriceCategoryRead
    | null
    | (ServiceJsonldPriceServiceReadServiceReadPriceCategoryRead & null);
  surcharge?: boolean;
  type?: string;
}

export interface PriceServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead {
  description?: string;
  id?: number;
  name?: string;
  priceCategory?:
    | PriceCategoryJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead
    | null
    | (PriceCategoryJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead & null);
  service?:
    | ServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead
    | null
    | (ServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead & null);
  surcharge?: boolean;
  type?: string;
}

export interface RankingJsonldRankingRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  context?: string;
  id?: number;
  ranking?: number;
}

export interface RankingJsonldSuggestedGarageReadRankingRead {
  "@id"?: string;
  "@type"?: string;
  context?: string;
  garage?: GarageJsonldSuggestedGarageReadRankingRead;
  id?: number;
  ranking?: number;
}

export interface ServiceJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead {
  id?: number;
  name?: string;
  parent?:
    | ServiceJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead
    | null
    | (ServiceJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead & null);
  slug?: string;
}

export interface ServiceJsonldPriceServiceReadServiceReadPriceCategoryRead {
  id?: number;
  name?: string;
  parent?:
    | ServiceJsonldPriceServiceReadServiceReadPriceCategoryRead
    | null
    | (ServiceJsonldPriceServiceReadServiceReadPriceCategoryRead & null);
  slug?: string;
}

export interface ServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead {
  id?: number;
  name?: string;
  parent?:
    | ServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead
    | null
    | (ServiceJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead & null);
  slug?: string;
}

export interface ServiceJsonldServiceRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  id?: number;
  name?: string;
  parent?: ServiceJsonldServiceRead | null | (ServiceJsonldServiceRead & null);
  slug?: string;
}

export interface ServiceJsonldSupportedServiceReadServiceRead {
  id?: number;
  name?: string;
  parent?: ServiceJsonldSupportedServiceReadServiceRead | null | (ServiceJsonldSupportedServiceReadServiceRead & null);
  slug?: string;
}

export interface SlugHistoryJsonldSlugHistoryReadGarageSlugHistoryRead {
  "@id"?: string;
  "@type"?: string;
  created?: string;
  garage?: GarageJsonldSlugHistoryReadGarageSlugHistoryRead;
  id?: number;
  slugName?: string;
}

export interface TagJsonldGarageTagReadTagRead {
  id?: number;
  name?: string;
  usage?: string;
}

export interface TagJsonldTagRead {
  "@context"?:
    | string
    | {
        "@vocab": string;
        hydra: "http://www.w3.org/ns/hydra/core#";
        [key: string]: any;
      };
  "@id"?: string;
  "@type"?: string;
  id?: number;
  name?: string;
  usage?: string;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Dobrymechanik Api
 * @version 1.0.0
 * @baseUrl /
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Retrieves the collection of Answer resources.
     *
     * @tags Answer
     * @name ApiAnswersGetCollection
     * @summary Retrieves the collection of Answer resources.
     * @request GET:/api/answers
     */
    apiAnswersGetCollection: (params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": AnswerJsonldAnswerRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/answers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a Answer resource.
     *
     * @tags Answer
     * @name ApiAnswersIdGet
     * @summary Retrieves a Answer resource.
     * @request GET:/api/answers/{id}
     */
    apiAnswersIdGet: (id: string, params: RequestParams = {}) =>
      this.request<AnswerJsonldAnswerRead, void>({
        path: `/api/answers/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of BrandSpecialization resources.
     *
     * @tags BrandSpecialization
     * @name ApiBrandSpecializationGetCollection
     * @summary Retrieves the collection of BrandSpecialization resources.
     * @request GET:/api/brand-specialization
     */
    apiBrandSpecializationGetCollection: (params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": BrandSpecializationJsonldSpecializationRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/brand-specialization`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a BrandSpecialization resource.
     *
     * @tags BrandSpecialization
     * @name ApiBrandSpecializationIdGet
     * @summary Retrieves a BrandSpecialization resource.
     * @request GET:/api/brand-specialization/{id}
     */
    apiBrandSpecializationIdGet: (id: string, params: RequestParams = {}) =>
      this.request<BrandSpecializationJsonldSpecializationRead, void>({
        path: `/api/brand-specialization/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageIdentifierBySlug resource.
     *
     * @tags GarageIdentifierBySlug
     * @name ApiGarageIdentifierBySlugSlugGet
     * @summary Retrieves a GarageIdentifierBySlug resource.
     * @request GET:/api/garage-identifier-by-slug/{slug}
     */
    apiGarageIdentifierBySlugSlugGet: (slug: string, params: RequestParams = {}) =>
      this.request<GarageIdentifierBySlugJsonldGarageRead, void>({
        path: `/api/garage-identifier-by-slug/${slug}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageAutobookingIntegration resource.
     *
     * @tags GarageAutobookingIntegration
     * @name ApiGarageGarageIdautobookingGet
     * @summary Retrieves a GarageAutobookingIntegration resource.
     * @request GET:/api/garage/{garageId}/autobooking
     */
    apiGarageGarageIdautobookingGet: (garageId: string, params: RequestParams = {}) =>
      this.request<GarageAutobookingIntegrationJsonldAutobookingIntegrationRead, void>({
        path: `/api/garage/${garageId}/autobooking`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageBrandSpecialization resources.
     *
     * @tags GarageBrandSpecialization
     * @name ApiGarageGarageIdbrandSpecializationGetCollection
     * @summary Retrieves the collection of GarageBrandSpecialization resources.
     * @request GET:/api/garage/{garageId}/brand-specialization
     */
    apiGarageGarageIdbrandSpecializationGetCollection: (garageId: string, params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": GarageBrandSpecializationJsonldBrandSpecializationReadSpecializationRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/brand-specialization`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageBrandSpecialization resource.
     *
     * @tags GarageBrandSpecialization
     * @name ApiGarageGarageIdbrandSpecializationIdGet
     * @summary Retrieves a GarageBrandSpecialization resource.
     * @request GET:/api/garage/{garageId}/brand-specialization/{id}
     */
    apiGarageGarageIdbrandSpecializationIdGet: (garageId: string, id: string, params: RequestParams = {}) =>
      this.request<GarageBrandSpecializationJsonldBrandSpecializationReadSpecializationRead, void>({
        path: `/api/garage/${garageId}/brand-specialization/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageComment resources.
     *
     * @tags GarageComment
     * @name ApiGarageGarageIdcommentsGetCollection
     * @summary Retrieves the collection of GarageComment resources.
     * @request GET:/api/garage/{garageId}/comments
     */
    apiGarageGarageIdcommentsGetCollection: (
      garageId: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 10
         */
        itemsPerPage?: number;
        state?: number;
        "state[]"?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          "hydra:member": GarageCommentJsonldGarageReadIdGarageReadNameCommentReadAnswerRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/comments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageCommentStatistics resources.
     *
     * @tags GarageCommentStatistics
     * @name ApiGarageGarageIdcommentsStatisticsGetCollection
     * @summary Retrieves the collection of GarageCommentStatistics resources.
     * @request GET:/api/garage/{garageId}/comments-statistics
     */
    apiGarageGarageIdcommentsStatisticsGetCollection: (
      garageId: string,
      query?: {
        state?: number;
        "state[]"?: number[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          "hydra:member": GarageCommentStatisticsJsonldCommentsStatisticsRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/comments-statistics`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageComment resource.
     *
     * @tags GarageComment
     * @name ApiGarageGarageIdcommentsIdGet
     * @summary Retrieves a GarageComment resource.
     * @request GET:/api/garage/{garageId}/comments/{id}
     */
    apiGarageGarageIdcommentsIdGet: (garageId: string, id: string, params: RequestParams = {}) =>
      this.request<GarageCommentJsonldCommentReadAnswerRead, void>({
        path: `/api/garage/${garageId}/comments/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageDomain resource.
     *
     * @tags GarageDomain
     * @name ApiGarageGarageIddomainGet
     * @summary Retrieves a GarageDomain resource.
     * @request GET:/api/garage/{garageId}/domain
     */
    apiGarageGarageIddomainGet: (garageId: string, params: RequestParams = {}) =>
      this.request<GarageDomainJsonldDomainRead, void>({
        path: `/api/garage/${garageId}/domain`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageFixedPriceList resources.
     *
     * @tags GarageFixedPriceList
     * @name ApiGarageGarageIdfixedPriceGetCollection
     * @summary Retrieves the collection of GarageFixedPriceList resources.
     * @request GET:/api/garage/{garageId}/fixed-price
     */
    apiGarageGarageIdfixedPriceGetCollection: (garageId: string, params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": GarageFixedPriceListJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/fixed-price`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageFixedPriceList resource.
     *
     * @tags GarageFixedPriceList
     * @name ApiGarageGarageIdfixedPriceIdGet
     * @summary Retrieves a GarageFixedPriceList resource.
     * @request GET:/api/garage/{garageId}/fixed-price/{id}
     */
    apiGarageGarageIdfixedPriceIdGet: (garageId: string, id: string, params: RequestParams = {}) =>
      this.request<
        GarageFixedPriceListJsonldFixedPriceListReadGarageReadIdPriceServiceReadServiceReadPriceCategoryRead,
        void
      >({
        path: `/api/garage/${garageId}/fixed-price/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageImage resources.
     *
     * @tags GarageImage
     * @name ApiGarageGarageIdimagesGetCollection
     * @summary Retrieves the collection of GarageImage resources.
     * @request GET:/api/garage/{garageId}/images
     */
    apiGarageGarageIdimagesGetCollection: (
      garageId: string,
      query?: {
        type?: string;
        "type[]"?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          "hydra:member": GarageImageJsonldGarageImageRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/images`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageImage resource.
     *
     * @tags GarageImage
     * @name ApiGarageGarageIdimagesIdGet
     * @summary Retrieves a GarageImage resource.
     * @request GET:/api/garage/{garageId}/images/{id}
     */
    apiGarageGarageIdimagesIdGet: (garageId: string, id: string, params: RequestParams = {}) =>
      this.request<GarageImageJsonldGarageImageRead, void>({
        path: `/api/garage/${garageId}/images/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageRangePriceList resources.
     *
     * @tags GarageRangePriceList
     * @name ApiGarageGarageIdrangePriceGetCollection
     * @summary Retrieves the collection of GarageRangePriceList resources.
     * @request GET:/api/garage/{garageId}/range-price
     */
    apiGarageGarageIdrangePriceGetCollection: (garageId: string, params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": GarageRangePriceListJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/range-price`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageRangePriceList resource.
     *
     * @tags GarageRangePriceList
     * @name ApiGarageGarageIdrangePriceIdGet
     * @summary Retrieves a GarageRangePriceList resource.
     * @request GET:/api/garage/{garageId}/range-price/{id}
     */
    apiGarageGarageIdrangePriceIdGet: (garageId: string, id: string, params: RequestParams = {}) =>
      this.request<
        GarageRangePriceListJsonldRangePriceListReadGarageReadIdServiceReadPriceServiceReadPriceCategoryRead,
        void
      >({
        path: `/api/garage/${garageId}/range-price/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageSupportedService resources.
     *
     * @tags GarageSupportedService
     * @name ApiGarageGarageIdsupportedServicesGetCollection
     * @summary Retrieves the collection of GarageSupportedService resources.
     * @request GET:/api/garage/{garageId}/supported-services
     */
    apiGarageGarageIdsupportedServicesGetCollection: (garageId: string, params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": GarageSupportedServiceJsonldSupportedServiceReadServiceRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/supported-services`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageSupportedService resource.
     *
     * @tags GarageSupportedService
     * @name ApiGarageGarageIdsupportedServicesIdGet
     * @summary Retrieves a GarageSupportedService resource.
     * @request GET:/api/garage/{garageId}/supported-services/{id}
     */
    apiGarageGarageIdsupportedServicesIdGet: (garageId: string, id: string, params: RequestParams = {}) =>
      this.request<GarageSupportedServiceJsonldSupportedServiceReadServiceRead, void>({
        path: `/api/garage/${garageId}/supported-services/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageTag resources.
     *
     * @tags GarageTag
     * @name ApiGarageGarageIdtagsGetCollection
     * @summary Retrieves the collection of GarageTag resources.
     * @request GET:/api/garage/{garageId}/tags
     */
    apiGarageGarageIdtagsGetCollection: (garageId: string, params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": GarageTagJsonldGarageTagReadTagRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/tags`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageTag resource.
     *
     * @tags GarageTag
     * @name ApiGarageGarageIdtagsIdGet
     * @summary Retrieves a GarageTag resource.
     * @request GET:/api/garage/{garageId}/tags/{id}
     */
    apiGarageGarageIdtagsIdGet: (garageId: string, id: string, params: RequestParams = {}) =>
      this.request<GarageTagJsonldGarageTagReadTagRead, void>({
        path: `/api/garage/${garageId}/tags/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of GarageVirtualPhoneNumber resources.
     *
     * @tags GarageVirtualPhoneNumber
     * @name ApiGarageGarageIdvirtualPhoneGetCollection
     * @summary Retrieves the collection of GarageVirtualPhoneNumber resources.
     * @request GET:/api/garage/{garageId}/virtual-phone
     */
    apiGarageGarageIdvirtualPhoneGetCollection: (
      garageId: string,
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        active?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          "hydra:member": GarageVirtualPhoneNumberJsonldVirtualPhoneRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garage/${garageId}/virtual-phone`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageVirtualPhoneNumber resource.
     *
     * @tags GarageVirtualPhoneNumber
     * @name ApiGarageGarageIdvirtualPhoneIdGet
     * @summary Retrieves a GarageVirtualPhoneNumber resource.
     * @request GET:/api/garage/{garageId}/virtual-phone/{id}
     */
    apiGarageGarageIdvirtualPhoneIdGet: (garageId: string, id: string, params: RequestParams = {}) =>
      this.request<GarageVirtualPhoneNumberJsonldVirtualPhoneRead, void>({
        path: `/api/garage/${garageId}/virtual-phone/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a GarageWorkTime resource.
     *
     * @tags GarageWorkTime
     * @name ApiGarageGarageIdworkTimeGet
     * @summary Retrieves a GarageWorkTime resource.
     * @request GET:/api/garage/{garageId}/work-time
     */
    apiGarageGarageIdworkTimeGet: (garageId: string, params: RequestParams = {}) =>
      this.request<GarageWorkTimeJsonldWorkTimeRead, void>({
        path: `/api/garage/${garageId}/work-time`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a Garage resource.
     *
     * @tags Garage
     * @name ApiGarageIdGet
     * @summary Retrieves a Garage resource.
     * @request GET:/api/garage/{id}
     */
    apiGarageIdGet: (id: string, params: RequestParams = {}) =>
      this.request<GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead, void>({
        path: `/api/garage/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of Garage resources.
     *
     * @tags Garage
     * @name ApiGaragesGetCollection
     * @summary Retrieves the collection of Garage resources.
     * @request GET:/api/garages
     */
    apiGaragesGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        "premium[between]"?: string;
        "premium[gt]"?: string;
        "premium[gte]"?: string;
        "premium[lt]"?: string;
        "premium[lte]"?: string;
        /**
         * Filter garages within range from given geo point!
         * @example "52.2243967_20.9575695_5000"
         */
        geo_localization_range?: string;
        /**
         * Filter garages within range from given geo point!
         * @example "52.2243967_20.9575695_5000"
         */
        "garage.geo_localization_range"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          "hydra:member": GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/garages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of PriceCategory resources.
     *
     * @tags PriceCategory
     * @name ApiPricingCategoryGetCollection
     * @summary Retrieves the collection of PriceCategory resources.
     * @request GET:/api/pricing-category
     */
    apiPricingCategoryGetCollection: (params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": PriceCategoryJsonld[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/pricing-category`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a PriceCategory resource.
     *
     * @tags PriceCategory
     * @name ApiPricingCategoryIdGet
     * @summary Retrieves a PriceCategory resource.
     * @request GET:/api/pricing-category/{id}
     */
    apiPricingCategoryIdGet: (id: string, params: RequestParams = {}) =>
      this.request<PriceCategoryJsonldPriceCategoryRead, void>({
        path: `/api/pricing-category/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of PriceService resources.
     *
     * @tags PriceService
     * @name ApiPricingServiceGetCollection
     * @summary Retrieves the collection of PriceService resources.
     * @request GET:/api/pricing-service
     */
    apiPricingServiceGetCollection: (
      query?: {
        type?: string;
        "type[]"?: string[];
        surcharge?: boolean;
        "surcharge[]"?: boolean[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          "hydra:member": PriceServiceJsonldPriceServiceReadServiceReadPriceCategoryRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/pricing-service`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a PriceService resource.
     *
     * @tags PriceService
     * @name ApiPricingServiceIdGet
     * @summary Retrieves a PriceService resource.
     * @request GET:/api/pricing-service/{id}
     */
    apiPricingServiceIdGet: (id: string, params: RequestParams = {}) =>
      this.request<PriceServiceJsonldPriceServiceReadServiceReadPriceCategoryRead, void>({
        path: `/api/pricing-service/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of Ranking resources.
     *
     * @tags Ranking
     * @name ApiRankingGetCollection
     * @summary Retrieves the collection of Ranking resources.
     * @request GET:/api/ranking
     */
    apiRankingGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 30
         */
        itemsPerPage?: number;
        context?: string;
        "context[]"?: string[];
        "garage.premium[between]"?: string;
        "garage.premium[gt]"?: string;
        "garage.premium[gte]"?: string;
        "garage.premium[lt]"?: string;
        "garage.premium[lte]"?: string;
        /**
         * Filter garages within range from given geo point!
         * @example "52.2243967_20.9575695_5000"
         */
        geo_localization_range?: string;
        /**
         * Filter garages within range from given geo point!
         * @example "52.2243967_20.9575695_5000"
         */
        "garage.geo_localization_range"?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          "hydra:member": RankingJsonldSuggestedGarageReadRankingRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/ranking`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a Ranking resource.
     *
     * @tags Ranking
     * @name ApiRankingIdGet
     * @summary Retrieves a Ranking resource.
     * @request GET:/api/ranking/{id}
     */
    apiRankingIdGet: (id: string, params: RequestParams = {}) =>
      this.request<RankingJsonldRankingRead, void>({
        path: `/api/ranking/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of Service resources.
     *
     * @tags Service
     * @name ApiServiceGetCollection
     * @summary Retrieves the collection of Service resources.
     * @request GET:/api/service
     */
    apiServiceGetCollection: (params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": ServiceJsonldServiceRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/service`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a Service resource.
     *
     * @tags Service
     * @name ApiServiceIdGet
     * @summary Retrieves a Service resource.
     * @request GET:/api/service/{id}
     */
    apiServiceIdGet: (id: string, params: RequestParams = {}) =>
      this.request<ServiceJsonldServiceRead, void>({
        path: `/api/service/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of SlugHistory resources.
     *
     * @tags SlugHistory
     * @name ApiSlugHistoryGetCollection
     * @summary Retrieves the collection of SlugHistory resources.
     * @request GET:/api/slug-history
     */
    apiSlugHistoryGetCollection: (
      query?: {
        /**
         * The collection page number
         * @default 1
         */
        page?: number;
        /**
         * The number of items per page
         * @min 0
         * @default 10
         */
        itemsPerPage?: number;
        slugName?: string;
        "slugName[]"?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          "hydra:member": SlugHistoryJsonldSlugHistoryReadGarageSlugHistoryRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/slug-history`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves the collection of Tag resources.
     *
     * @tags Tag
     * @name ApiTagsGetCollection
     * @summary Retrieves the collection of Tag resources.
     * @request GET:/api/tags
     */
    apiTagsGetCollection: (params: RequestParams = {}) =>
      this.request<
        {
          "hydra:member": TagJsonldTagRead[];
          "hydra:search"?: {
            "@type"?: string;
            "hydra:mapping"?: {
              "@type"?: string;
              property?: string | null;
              required?: boolean;
              variable?: string;
            }[];
            "hydra:template"?: string;
            "hydra:variableRepresentation"?: string;
          };
          /** @min 0 */
          "hydra:totalItems"?: number;
          /** @example {"@id":"string","hydra:first":"string","hydra:last":"string","hydra:next":"string","hydra:previous":"string","type":"string"} */
          "hydra:view"?: {
            /** @format iri-reference */
            "@id"?: string;
            "@type"?: string;
            /** @format iri-reference */
            "hydra:first"?: string;
            /** @format iri-reference */
            "hydra:last"?: string;
            /** @format iri-reference */
            "hydra:next"?: string;
            /** @format iri-reference */
            "hydra:previous"?: string;
          };
        },
        any
      >({
        path: `/api/tags`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieves a Tag resource.
     *
     * @tags Tag
     * @name ApiTagsIdGet
     * @summary Retrieves a Tag resource.
     * @request GET:/api/tags/{id}
     */
    apiTagsIdGet: (id: string, params: RequestParams = {}) =>
      this.request<TagJsonldTagRead, void>({
        path: `/api/tags/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
